var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Live.Layers = OCS.Viewer.Live.Layers || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.AbstractLayer = new Class({
    Implements: [Options, Events, new Class(OCS.Viewer.Interfaces.OlObject), new Class(OCS.Viewer.Interfaces.OlEvent)],
    bound_events: {},
    class_type: "Layer",
    class_name: "AbstractLayer",
    style_manager: null,
    style_manager_class: OCS.Viewer.Classes.OlStyleManager,
    visible: false,
    is_ready: false,
    options: {
        debug: false,
        layer_style_ops: {},
        projection: OCS.Viewer.Config.default_projection,
        display_projection: OCS.Viewer.Config.default_display_projection,
    },
    initialize: function (op) {
        this.setOptions(op);
        if (this.add_legend_events) {
            this.add_legend_events();
        }
        if(OCS.Settings.debug) {
            OCS.Viewer.Live.Layers[this.get_id()] = this;
        }
    },
    /*
     * 
     * Action methods
     * 
     */
    init: function () {

    },
    init_events: function () {

    },

    create: function () {
        // Defined in the child classes
    },
    make_visible: function () {
        this.set_visible(true);
    },
    make_invisible: function () {
        this.set_visible(false);
    },

    changed: function () {
        if (this.ol_object) {
            this.ol_object.changed();
        }
    },
    display_debug_data: function () {
        return '';
    },
    refresh_style: function() {
        
    },
    /*
     * Boolean test methods
     */
    is_static: function () {

    },
    is_visible: function () {
        return this.visible;
    },
    test_data: function () {
        return true;
    },

    /*
     * 
     * Getter and Setter methods
     * 
     */
    get_canvas: function () {

    },
    get_opacity: function () {
        return this.get_ol_object().getOpacity();
    },
    set_opacity: function (opacity) {
        this.get_ol_object().setOpacity(opacity);
    },
    set_style: function(style) {
        
    },
    get_layer: function () {
        return this.get_ol_object();
    },
    get_layer_cat_type: function () {
        var layer_arr = ['gradient', 'shape', 'contour', 'point', 'radar', 'obs', 'vector'];
        return ($.inArray(this.options.layer_type, layer_arr) !== -1) ? this.options.layer_type : 'shape';
    },
    get_layer_name: function () {
        if (!this.options.layer_name) {
            var dataset_obj = this.get_dataset_obj();
            var variables = this.get_variables();
            var class_type_array = this.options.layer_class.split("Layer");
            var class_type = class_type_array[class_type_array.length - 1];
            var parm_name = "";
            if (variables && variables.length) {
                var util = OCS.Viewer.Functions.get_utilities();
                parm_name = util.get_parm_name(variables[0].parm);
            }
            this.options.layer_name = dataset_obj.getOption("name") + " " + parm_name.toLowerCase().capitalize() + " " + class_type.toLowerCase().capitalize();
        }
        return this.options.layer_name;

    },
    get_layer_short_name: function () {
        if (this.options.layer_short_name) {
            return this.options.layer_short_name;
        }
        var short_name;
        var variables = this.get_variables();
        if (variables && variables.length) {
            var util = OCS.Viewer.Functions.get_utilities();
            short_name = util.get_parm_short_name(variables[0].parm).toLowerCase().capitalize();
        } else {
            short_name = "layer";
        }
        this.options.layer_short_name = short_name;
        return short_name;
    },

    get_layer_type: function () {
        return this.options.layer_type;
    },
    get_layer_visibility_text: function () {
        return (this.is_visible()) ? 'on' : 'off';
    },
    set_layer: function (l) {
        this.set_ol_object(l);
        this.init_events();
    },
    set_visible: function (condition) {
        this.visible = condition;
        var layer = this.get_ol_object();
        if (layer) {
            layer.setVisible(condition);
            layer.visible = condition;
        }
    },
    get_style_manager: function () {
        if (!this.style_manager) {
            this.style_manager = new this.style_manager_class();
            this.style_manager.set_layer_style_ops(this.options.layer_style_ops);
        }
        return this.style_manager;
    },
    set_style_manager: function (sm) {
        this.style_manager = sm;
    },

    /*
     * Event Fires 
     */
    ready: function () {
        if (!this.is_ready) {
            this.is_ready = true;
            this.create();
            this.fireEvent('ready', this, 1);
        }
    },
    mouse_click: function (mouse_position) {
        if (this.allow_mouse_select) {
            this.fireEvent('mouse_click', [{mouse_position: mouse_position}, this], 1);
        }
    },
    mouse_over: function (mouse_position) {
        if (this.allow_mouse_over) {
            this.fireEvent('mouse_over', [{mouse_position: mouse_position}, this], 1);
        }
    },
    /*
     * Event listeners
     */
    on_mouse_click: function (mouse_position) {

    },
    on_mouse_over: function (mouse_position) {

    },
    /*
     * Delete and destroy methods
     */
    destroy: function () {
        this.delete();
    },

    delete: function () {
        if(OCS.Settings.debug) {
            delete OCS.Viewer.Live.Layers[this.get_id()];
        }
        this.options.layer_style_ops = {};
        this.style_manager = null;
        this.remove_all_events();
        this.removeEvents();
        this.$events = {};
        delete this.options;
        this.set_ol_object(null);
    }
});
